var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indemnite-kilometrique-list"},[_c('PageHeader',{attrs:{"title":"Histoire d'indemnite kilometrique","has-back":true},on:{"back":_vm.goBack}}),_c('sortable-list',{attrs:{"items":_vm.data,"parameters":_vm.listParameters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }